export default __webpack_public_path__ + "static/media/holidays.6d83f704.svg";